import r from "./index681.js";
import o from "./index682.js";
import t from "./index683.js";
import { withInstall as i, withNoopInstall as p } from "./index604.js";
const f = i(r, {
  Option: o,
  OptionGroup: t
}), s = p(o);
p(t);
export {
  s as ElOption,
  f as ElSelect,
  f as default
};
